import { Button } from '@platform/design-system';
import { useTranslation } from '@platform/i18n';
import styles from './LoadMore.module.css';

export type LoadMoreProps = {
  shownLabel: string;
  hasMore: boolean;
  loading: boolean;
  onLoadMore: () => void;
};

export const LoadMore = ({ shownLabel, hasMore, loading, onLoadMore }: LoadMoreProps) => {
  const { t } = useTranslation();
  return (
    <div className={styles['more']}>
      <span role="status">{shownLabel}</span>
      {hasMore ? (
        <Button variant="outline" size="sm" disabled={loading} onClick={onLoadMore}>
          {loading ? t('common.loadingMore') : t('common.loadMore')}
        </Button>
      ) : null}
    </div>
  );
};
